module.exports = __webpack_public_path__ + "static/img/aphv.81ee5fad.svg";